import React, { useEffect, useRef, useState } from 'react';
// ✅ Combine both imports into one statement
import { SimliClient, generateSimliSessionToken } from 'simli-client';

const SimliAvatar = ({
  isSpeaking = false,
  isThinking = false,
  isListening = false,
  text = '',
  onAvatarReady,
  onSpeechComplete,
}) => {
  const videoRef = useRef(null);
  const audioRef = useRef(null);
  const simliClientRef = useRef(null);

  const [isConnected, setIsConnected] = useState(false);
  const [connectionError, setConnectionError] = useState(null);
  const [isInitializing, setIsInitializing] = useState(true);

  // Maintain fresh callback references
  const onAvatarReadyRef = useRef(onAvatarReady);
  const onSpeechCompleteRef = useRef(onSpeechComplete);

  useEffect(() => {
    onAvatarReadyRef.current = onAvatarReady;
  }, [onAvatarReady]);

  useEffect(() => {
    onSpeechCompleteRef.current = onSpeechComplete;
  }, [onSpeechComplete]);

  // Expose audio streaming interface on window for easy interaction from external TTS handlers
  useEffect(() => {
    window.sendAudioToSimli = (pcmData) => {
      if (simliClientRef.current && isConnected) {
        // pcmData must be a Uint8Array of 16kHz 16-bit PCM audio
        simliClientRef.current.sendAudioData(pcmData);
      } else {
        console.warn('⚠️ [Simli] Cannot send audio. Client not connected.');
      }
    };

    return () => {
      delete window.sendAudioToSimli;
    };
  }, [isConnected]);

  

// ✅ Valid JavaScript - no type annotations
async function getSessionToken() {
  const SimliConfig = {
    faceId: process.env.REACT_APP_SIMLI_FACE_ID,
    maxSessionLength: 600,
    maxIdleTime: 180,
  };

  try {
    const response = await generateSimliSessionToken({
      apiKey: process.env.REACT_APP_SIMLI_API_KEY,
      config: SimliConfig
    });

    return response.session_token;
  } catch (error) {
    console.error("Failed to generate session token:", error);
    throw error;
  }
}



  // ==============================
  // INITIALIZE SIMLI CLIENT (v2.0.0 API)
  // ==============================
 useEffect(() => {
  let isMounted = true;

  // const initSimli = async () => {
  //   try {
  //     console.log('🔄 [Simli] Starting initialization...');

  //     const apiKey = process.env.REACT_APP_SIMLI_API_KEY;
  //     const faceId = process.env.REACT_APP_SIMLI_FACE_ID;

  //     // 1. Guard against missing credentials
  //     if (!apiKey || !faceId) {
  //       console.error('❌ [Simli] Missing API key or Face ID');
  //       if (isMounted) setConnectionError('Missing SIMLI API credentials');
  //       return;
  //     }

  //     // 2. Guard against unmounted DOM refs
  //     if (!videoRef.current || !audioRef.current) {
  //       console.error('❌ [Simli] Video or Audio DOM element is not mounted yet');
  //       return;
  //     }

  //     const client = new SimliClient();
  //     simliClientRef.current = client;

  //     client.on('connected', () => {
  //       console.log('✅ [Simli] WebRTC Connected!');
  //       if (isMounted) {
  //         setIsConnected(true);
  //         setIsInitializing(false);
  //         if (onAvatarReadyRef.current) onAvatarReadyRef.current();
  //       }
  //     });

  //     client.on('failed', (err) => {
  //       console.error('❌ [Simli] Connection failed:', err);
  //       if (isMounted) {
  //         setConnectionError('Simli connection failed');
  //         setIsConnected(false);
  //       }
  //     });

  //     // 3. Pass .current DOM nodes to SimliClient
  //     await client.Initialize({
  //        apiKey,
  //        faceId,
  //       handleSilent: true,
  //       videoRef: videoRef.current, // <-- FIX: pass .current
  //       audioRef: audioRef.current, // <-- FIX: pass .current
  //     });

  //     await client.start();
  //   } catch (error) {
  //     console.error('❌ [Simli] Initialization Exception:', error);
  //     if (isMounted) setConnectionError(error.message);
  //   }
  // };

const initSimli = async () => {
  try {
    console.log('=================================================');
    console.log('🔄 [Simli 01] Starting initialization...');
    console.log('=================================================');

    console.log('🔄 [Simli 02] Reading API key...');
    const apiKey = process.env.REACT_APP_SIMLI_API_KEY;
    console.log('✅ [Simli 03] API key exists:', !!apiKey);
    console.log('🔍 [Simli 04] API key length:', apiKey?.length);

    console.log('🔄 [Simli 05] Reading Face ID...');
    const faceId = process.env.REACT_APP_SIMLI_FACE_ID;
    console.log('✅ [Simli 06] Face ID:', faceId);

    // -----------------------------------------
    // 1. Check credentials
    // -----------------------------------------

    console.log('🔍 [Simli 07] Checking credentials...');

    if (!apiKey || !faceId) {
      console.error('❌ [Simli 08] Missing API key or Face ID');
      console.error('❌ [Simli 09] API key exists:', !!apiKey);
      console.error('❌ [Simli 10] Face ID exists:', !!faceId);

      if (isMounted) {
        console.log('🔄 [Simli 11] Setting connection error...');
        setConnectionError('Missing SIMLI API credentials');
      }

      console.log('🛑 [Simli 12] Returning because credentials are missing');
      return;
    }

    console.log('✅ [Simli 13] Credentials check passed');

    // -----------------------------------------
    // 2. Check DOM refs
    // -----------------------------------------

    console.log('🔄 [Simli 14] Checking videoRef...');
    console.log('🔍 [Simli 15] videoRef:', videoRef);
    console.log('🔍 [Simli 16] videoRef.current:', videoRef.current);
    console.log(" 222222222222222get session token =======>>>>>>>>>",getSessionToken)
    console.log('🔄 [Simli 17] Checking audioRef...');
    console.log('🔍 [Simli 18] audioRef:', audioRef);
    console.log('🔍 [Simli 19] audioRef.current:', audioRef.current);

   if (!videoRef.current || !audioRef.current) {
  console.error('❌ [Simli] Video or Audio DOM element is not mounted');
  console.error('video exists:', !!videoRef.current);
  console.error('audio exists:', !!audioRef.current);
  return;
}

console.log('🎥 videoRef:', videoRef.current);
console.log('🎥 video instanceof HTMLVideoElement:',
  videoRef.current instanceof HTMLVideoElement
);

console.log('🔊 audioRef:', audioRef.current);
console.log('🔊 audio instanceof HTMLAudioElement:',
  audioRef.current instanceof HTMLAudioElement
);

    console.log('✅ [Simli 24] Video DOM element is ready');
    console.log('✅ [Simli 25] Audio DOM element is ready');

    // -----------------------------------------
    // 3. Create Simli Client
    // -----------------------------------------

    console.log('🔄 [Simli 26] Creating SimliClient...');

    const client = new SimliClient();

    // await client.Initialize({
    //   apiKey,
    //   faceId,
    //   handleSilent: true,
    //   videoRef: videoRef.current,
    //   audioRef: audioRef.current,
    //   });

    console.log('✅ [Simli 27] SimliClient created');
    console.log('🔍 [Simli 28] Simli client object:', client);

    simliClientRef.current = client;

    console.log('✅ [Simli 29] Simli client stored in simliClientRef');
    console.log('🔍 [Simli 30] simliClientRef.current:', simliClientRef.current);

    // -----------------------------------------
    // 4. Connected event
    // -----------------------------------------

    console.log('🔄 [Simli 31] Registering connected event...');

    client.on('connected', () => {
      console.log('=================================================');
      console.log('🎉 [Simli 32] WEBRTC CONNECTED');
      console.log('=================================================');

      console.log('🔍 [Simli 33] isMounted:', isMounted);

      if (isMounted) {
        console.log('🔄 [Simli 34] Setting isConnected = true');
        setIsConnected(true);

        console.log('🔄 [Simli 35] Setting isInitializing = false');
        setIsInitializing(false);

        console.log(
          '🔍 [Simli 36] onAvatarReadyRef.current:',
          onAvatarReadyRef.current
        );

        if (onAvatarReadyRef.current) {
          console.log('🔄 [Simli 37] Calling onAvatarReady callback...');
          onAvatarReadyRef.current();
          console.log('✅ [Simli 38] onAvatarReady callback completed');
        } else {
          console.log('⚠️ [Simli 39] onAvatarReady callback is not available');
        }
      }
    });

    console.log('✅ [Simli 40] Connected event registered');

    // -----------------------------------------
    // 5. Failed event
    // -----------------------------------------

    console.log('🔄 [Simli 41] Registering failed event...');

    client.on('failed', (err) => {
      console.error('=================================================');
      console.error('❌ [Simli 42] SIMLI CONNECTION FAILED');
      console.error('=================================================');

      console.error('❌ [Simli 43] Error:', err);
      console.error('❌ [Simli 44] Error message:', err?.message);
      console.error('❌ [Simli 45] Error stack:', err?.stack);
      console.error('❌ [Simli 46] Full error JSON:', JSON.stringify(err, null, 2));

      if (isMounted) {
        console.log('🔄 [Simli 47] Setting connection error...');
        setConnectionError('Simli connection failed');

        console.log('🔄 [Simli 48] Setting isConnected = false');
        setIsConnected(false);
      }
    });

    console.log('✅ [Simli 49] Failed event registered');

    // -----------------------------------------
    // 6. Initialize Simli
    // -----------------------------------------

    console.log('=================================================');
    console.log('🔄 [Simli 50] Calling client.Initialize()...');
    console.log('=================================================');

    console.log('📦 [Simli 51] Initialize parameters:', {
      hasApiKey: !!apiKey,
      apiKeyLength: apiKey?.length,
      faceId,
      handleSilent: true,
      videoElement: videoRef.current,
      audioElement: audioRef.current,
    });

    console.log('🔄 [Simli 52] Waiting for Initialize() response...');

    try {
  console.log("🚀 Starting Simli Initialize");

  await client.Initialize({
    sessionToken: await getSessionToken(),
    apiKey,
    faceID: faceId,
    handleSilent: true,
    videoRef: videoRef.current,
    audioRef: audioRef.current,
  });

  console.log("✅ Initialize completed");
  console.log("Client:", client);

} catch (error) {
  console.error("❌ Initialize failed:", error);
}

    // const initializeResult = await client.Initialize({
    //   apiKey,
    //   faceId,
    //   handleSilent: true,
    //   videoRef: videoRef.current,
    //   audioRef: audioRef.current,
    // });

    // console.log('=================================================', {
    //   apiKey,
    //   faceId,
    //   handleSilent: true,
    //   videoRef: videoRef.current,
    //   audioRef: audioRef.current,
    // });
    // console.log('✅ [Simli 53] client.Initialize() SUCCESS');
    // console.log('=================================================');

    // console.log('🔍 [Simli 54] Initialize result:', initializeResult);

    // -----------------------------------------
    // 7. Start Simli
    // -----------------------------------------

    console.log('=================================================');
    console.log('🚀 [Simli 55] Calling client.start()...');
    console.log('=================================================');

    console.log('🔄 [Simli 56] Waiting for start() response...');

    const startResult = await client.start();

    console.log('=================================================');
    console.log('✅ [Simli 57] client.start() SUCCESS');
    console.log('=================================================');

    console.log('🔍 [Simli 58] Start result:', startResult);

  } catch (error) {
    console.error('=================================================');
    console.error('💥 [Simli 59] INITIALIZATION EXCEPTION');
    console.error('=================================================');

    console.error('❌ [Simli 60] Error object:', error);
    console.error('❌ [Simli 61] Error message:', error?.message);
    console.error('❌ [Simli 62] Error name:', error?.name);
    console.error('❌ [Simli 63] Error stack:', error?.stack);

    console.error(
      '❌ [Simli 64] Error response:',
      error?.response
    );

    console.error(
      '❌ [Simli 65] Error response data:',
      error?.response?.data
    );

    console.error(
      '❌ [Simli 66] Error response status:',
      error?.response?.status
    );

    console.error(
      '❌ [Simli 67] Error response headers:',
      error?.response?.headers
    );

    if (isMounted) {
      console.log('🔄 [Simli 68] Setting connection error...');

      setConnectionError(
        error?.response?.data?.message ||
        error?.message ||
        'Simli initialization failed'
      );
    }

    console.log('🛑 [Simli 69] initSimli() finished with error');
  }
};

  initSimli();

  return () => {
    isMounted = false;
    if (simliClientRef.current) {
      try {
        simliClientRef.current.close();
      } catch (e) {
        /* ignore */
      }
    }
  };
}, []);

  // ==============================
  // UI RENDER
  // ==============================
  return (
    <div
      className="simli-avatar-container"
      style={{
        width: '100%',
        height: '100%',
        position: 'relative',
        backgroundColor: '#0a0a1a',
        overflow: 'hidden',
        borderRadius: '8px',
      }}
    >
      <div
        className="avatar-video-wrapper"
        style={{
          width: '100%',
          height: '100%',
          position: 'relative',
          background: 'radial-gradient(ellipse at center, #1a1a3e 0%, #0a0a1a 100%)',
        }}
      >
        {/* Loading Overlay */}
        {isInitializing && !isConnected && !connectionError && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(0,0,0,0.8)',
              zIndex: 10,
              borderRadius: '8px',
            }}
          >
            <div
              style={{
                fontSize: '48px',
                marginBottom: '16px',
                animation: 'float 2s ease-in-out infinite',
              }}
            >
              🤖
            </div>
            <div
              style={{
                fontSize: '16px',
                color: 'rgba(255,255,255,0.8)',
                fontWeight: 500,
                marginBottom: '12px',
              }}
            >
              Loading Avatar...
            </div>
            <div
              style={{
                display: 'flex',
                gap: '8px',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <span
                style={{
                  display: 'inline-block',
                  width: '10px',
                  height: '10px',
                  background: '#4CAF50',
                  borderRadius: '50%',
                  animation: 'dotPulse 1.4s ease-in-out infinite',
                }}
              />
              <span
                style={{
                  display: 'inline-block',
                  width: '10px',
                  height: '10px',
                  background: '#4CAF50',
                  borderRadius: '50%',
                  animation: 'dotPulse 1.4s ease-in-out 0.2s infinite',
                }}
              />
              <span
                style={{
                  display: 'inline-block',
                  width: '10px',
                  height: '10px',
                  background: '#4CAF50',
                  borderRadius: '50%',
                  animation: 'dotPulse 1.4s ease-in-out 0.4s infinite',
                }}
              />
            </div>
          </div>
        )}

        {/* Video stream element */}
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted
          className="avatar-video"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
            visibility: 'visible',
            background: 'transparent',
          }}
        />

        {/* Audio stream element */}
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <audio ref={audioRef} autoPlay />

        {/* Dynamic Activity Indicators */}
        {isConnected && (
          <div
            style={{
              position: 'absolute',
              bottom: '50px',
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 5,
            }}
          >
            {isSpeaking && (
              <div
                style={{
                  display: 'flex',
                  gap: '6px',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'rgba(0,0,0,0.5)',
                  padding: '8px 16px',
                  borderRadius: '20px',
                  backdropFilter: 'blur(8px)',
                }}
              >
                {[1, 2, 3, 4, 5].map((i) => (
                  <span
                    key={i}
                    style={{
                      display: 'inline-block',
                      width: '4px',
                      height: `${15 + i * 5}px`,
                      background: '#4CAF50',
                      borderRadius: '2px',
                      animation: `wave 0.8s ease-in-out ${i * 0.15}s infinite`,
                    }}
                  />
                ))}
              </div>
            )}

            {isThinking && (
              <div
                style={{
                  display: 'flex',
                  gap: '8px',
                  alignItems: 'center',
                  background: 'rgba(0,0,0,0.5)',
                  padding: '8px 16px',
                  borderRadius: '20px',
                  backdropFilter: 'blur(8px)',
                }}
              >
                {[1, 2, 3].map((i) => (
                  <span
                    key={i}
                    style={{
                      display: 'inline-block',
                      width: '10px',
                      height: '10px',
                      background: '#FFA726',
                      borderRadius: '50%',
                      animation: `dotPulse 1.4s ease-in-out ${i * 0.2}s infinite`,
                    }}
                  />
                ))}
              </div>
            )}

            {isListening && (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  background: 'rgba(0,0,0,0.5)',
                  padding: '8px 16px',
                  borderRadius: '20px',
                  backdropFilter: 'blur(8px)',
                }}
              >
                <div
                  style={{
                    width: '30px',
                    height: '30px',
                    border: '3px solid #4CAF50',
                    borderRadius: '50%',
                    animation: 'pulseRing 1.5s ease-in-out infinite',
                  }}
                />
              </div>
            )}
          </div>
        )}

        {/* Text Subtitle Overlay */}
        {isConnected && text && (isSpeaking || isThinking) && (
          <div
            style={{
              position: 'absolute',
              bottom: '100px',
              left: '50%',
              transform: 'translateX(-50%)',
              background: 'rgba(0,0,0,0.85)',
              color: 'white',
              padding: '10px 20px',
              borderRadius: '16px',
              maxWidth: '85%',
              fontSize: '14px',
              textAlign: 'center',
              backdropFilter: 'blur(8px)',
              border: '1px solid rgba(255,255,255,0.1)',
              zIndex: 5,
              wordBreak: 'break-word',
              boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
            }}
          >
            <p style={{ margin: 0, lineHeight: 1.5 }}>{text}</p>
          </div>
        )}

        {/* Error Display Card */}
        {connectionError && (
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              color: '#ff6b6b',
              background: 'rgba(0,0,0,0.92)',
              padding: '20px 28px',
              borderRadius: '16px',
              fontSize: '14px',
              textAlign: 'center',
              zIndex: 20,
              border: '2px solid #ff6b6b',
              maxWidth: '90%',
              boxShadow: '0 8px 32px rgba(255,0,0,0.2)',
            }}
          >
            <div style={{ fontSize: '32px', marginBottom: '12px' }}>⚠️</div>
            <div style={{ marginBottom: '16px', fontWeight: 500 }}>{connectionError}</div>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '10px 24px',
                background: 'linear-gradient(135deg, #4CAF50, #45a049)',
                border: 'none',
                borderRadius: '8px',
                color: 'white',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 600,
              }}
            >
              🔄 Retry Connection
            </button>
          </div>
        )}
      </div>

      {/* Footer Status Bar */}
      <div
        style={{
          position: 'absolute',
          bottom: '6px',
          left: '50%',
          transform: 'translateX(-50%)',
          fontSize: '11px',
          color: 'rgba(255,255,255,0.6)',
          background: 'rgba(0,0,0,0.7)',
          padding: '3px 14px',
          borderRadius: '12px',
          backdropFilter: 'blur(4px)',
          zIndex: 3,
          textAlign: 'center',
          whiteSpace: 'nowrap',
          border: '1px solid rgba(255,255,255,0.05)',
        }}
      >
        {isInitializing && !isConnected && !connectionError && (
          <span style={{ color: '#FFA726' }}>🔌 Connecting WebRTC...</span>
        )}
        {connectionError && <span style={{ color: '#ff6b6b' }}>❌ {connectionError}</span>}
        {isConnected && isSpeaking && <span style={{ color: '#4CAF50' }}>🗣️ Speaking...</span>}
        {isConnected && isThinking && !isSpeaking && (
          <span style={{ color: '#FFA726' }}>🤔 Thinking...</span>
        )}
        {isConnected && isListening && !isSpeaking && !isThinking && (
          <span style={{ color: '#4CAF50' }}>👂 Listening...</span>
        )}
        {isConnected && !isSpeaking && !isThinking && !isListening && (
          <span style={{ color: '#4CAF50' }}>✅ Ready</span>
        )}
      </div>
    </div>
  );
};

// Insert CSS Animations into DOM Head
if (typeof window !== 'undefined') {
  const styleId = 'simli-avatar-styles';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      @keyframes wave {
        0%, 100% { transform: scaleY(0.5); }
        50% { transform: scaleY(1.5); }
      }
      @keyframes dotPulse {
        0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
        40% { transform: scale(1.2); opacity: 1; }
      }
      @keyframes pulseRing {
        0% { transform: scale(0.8); opacity: 0.8; }
        100% { transform: scale(1.8); opacity: 0; }
      }
      @keyframes float {
        0%, 100% { transform: translateY(0px); }
        50% { transform: translateY(-10px); }
      }
    `;
    document.head.appendChild(style);
  }
}

export default SimliAvatar;


// import React, { useEffect, useRef, useState } from 'react';
// import { SimliClient } from 'simli-client';

// const SimliAvatar = ({
//   isSpeaking = false,
//   isThinking = false,
//   isListening = false,
//   text = '',
//   emotion = 'neutral',
//   onAvatarReady,
//   onSpeechComplete,
// }) => {
//   const videoRef = useRef(null);
//   const audioRef = useRef(null);
//   const simliClientRef = useRef(null);

//   const [isConnected, setIsConnected] = useState(false);

//   // Keep callbacks stable
//   const onAvatarReadyRef = useRef(onAvatarReady);
//   const onSpeechCompleteRef = useRef(onSpeechComplete);

//   useEffect(() => {
//     onAvatarReadyRef.current = onAvatarReady;
//   }, [onAvatarReady]);

//   useEffect(() => {
//     onSpeechCompleteRef.current = onSpeechComplete;
//   }, [onSpeechComplete]);

//   // ==============================
//   // INITIALIZE SIMLI
//   // ==============================
//   useEffect(() => {
//     let isMounted = true;

//     const initSimli = async () => {
//       try {
//         const videoElement = videoRef.current;
//       const audioElement = audioRef.current;

//       if (!videoElement) {
//         console.error('❌ Simli video element not available');
//         return;
//       }

//       if (!audioElement) {
//         console.error('❌ Simli audio element not available');
//         return;
//       }

//       console.log('🎥 Video element:', videoElement);
//       console.log('🔊 Audio element:', audioElement);


//         const apiKey = process.env.REACT_APP_SIMLI_API_KEY;
//         const faceId = process.env.REACT_APP_SIMLI_FACE_ID;

//         console.log('Simli Face ID:', faceId);
//         console.log('Simli API key exists:', !!apiKey);

//         if (!apiKey) {
//           console.error('❌ REACT_APP_SIMLI_API_KEY is missing');
//           return;
//         }

//         if (!faceId) {
//           console.error('❌ REACT_APP_SIMLI_FACE_ID is missing');
//           return;
//         }

//         const client = new SimliClient();

//         simliClientRef.current = client;

//         await client.Initialize({
//           apiKey,
//           faceId,
//           videoRef: videoElement,
//           audioRef: audioElement,

//           // onReady: () => {
//           //   if (!isMounted) return;

//           //   console.log('✅ Simli Avatar Ready');

//           //   setIsConnected(true);

//           //   if (onAvatarReadyRef.current) {
//           //     onAvatarReadyRef.current();
//           //   }
//           // },

//           onReady: () => {
//   if (!isMounted) return;

//   console.log('✅ Simli Avatar Ready');

//   setIsConnected(true);

//   // ✅ NOTIFY BACKEND THAT AVATAR IS READY
//   // This tells the backend to switch from SIMULATED to REAL mode
//   if (window.__socket && window.__socket.connected) {
//     window.__socket.emit('avatar_ready', {
//       socketId: window.__socket.id,
//       avatarReady: true
//     });
//     console.log('📤 Sent avatar_ready to backend');
//   } else {
//     console.warn('⚠️ Socket not available, cannot send avatar_ready');
//     // If socket isn't available yet, try again after a delay
//     setTimeout(() => {
//       if (window.__socket && window.__socket.connected) {
//         window.__socket.emit('avatar_ready', {
//           socketId: window.__socket.id,
//           avatarReady: true
//         });
//         console.log('📤 Sent avatar_ready to backend (delayed)');
//       }
//     }, 1000);
//   }

//   if (onAvatarReadyRef.current) {
//     onAvatarReadyRef.current();
//   }
// },

//           onStateChange: (state) => {
//             console.log('🤖 Simli state:', state);
//           },

//           onError: (error) => {
//             console.error('❌ Simli error:', error);
//           },
//         });

//       } catch (error) {
//         console.error('❌ Failed to initialize Simli:', error);
//       }
//     };

//     initSimli();

//     return () => {
//       isMounted = false;

//       if (simliClientRef.current) {
//         try {
//           simliClientRef.current.close();
//         } catch (error) {
//           console.warn('Simli cleanup error:', error);
//         }

//         simliClientRef.current = null;
//       }

//       setIsConnected(false);
//     };
//   }, []);

//   // ==============================
//   // SPEAK
//   // ==============================
//   useEffect(() => {
//     if (
//       !simliClientRef.current ||
//       !isConnected ||
//       !isSpeaking ||
//       !text
//     ) {
//       return;
//     }

//     console.log('🗣️ Simli speaking:', text);

//     try {
//       simliClientRef.current.speak({
//         text,
//         emotion: emotion || 'neutral',
//         rate: 1.0,

//         onComplete: () => {
//           console.log('✅ Simli speech completed');

//           if (onSpeechCompleteRef.current) {
//             onSpeechCompleteRef.current();
//           }
//         },
//       });
//     } catch (error) {
//       console.error('❌ Simli speak error:', error);
//     }
//   }, [isSpeaking, text, emotion, isConnected]);

//   // ==============================
//   // LISTENING STATE
//   // ==============================
//   useEffect(() => {
//     if (!simliClientRef.current || !isConnected) {
//       return;
//     }

//     try {
//       if (typeof simliClientRef.current.setListeningState === 'function') {
//         simliClientRef.current.setListeningState(isListening);
//       }
//     } catch (error) {
//       console.warn('Listening state error:', error);
//     }
//   }, [isListening, isConnected]);

//   return (
//     <div className="simli-avatar-container">

//       <div className="avatar-video-wrapper">

//         <video
//           ref={videoRef}
//           autoPlay
//           playsInline
//           muted={false}
//           className="avatar-video"
//           style={{
//             width: '100%',
//             height: '100%',
//             objectFit: 'cover',
//           }}
//         >
//             <track
//     kind="captions"
//     src="/captions.vtt"
//     srcLang="en"
//     label="English"
//   />
//       </video>

//         <audio
//           ref={audioRef}
//           autoPlay
//         >
//             <track
//     kind="captions"
//     src="/captions.vtt"
//     srcLang="en"
//     label="English"
//   />
//   </audio>

//         {/* ==============================
//             STATE OVERLAY
//         ============================== */}

//         <div className={`avatar-state-overlay ${emotion}`}>

//           {isSpeaking && (
//             <div className="speaking-indicator">
//               <span className="wave-bar" />
//               <span className="wave-bar" />
//               <span className="wave-bar" />
//               <span className="wave-bar" />
//               <span className="wave-bar" />
//             </div>
//           )}

//           {isThinking && (
//             <div className="thinking-indicator">
//               <span className="dot" />
//               <span className="dot" />
//               <span className="dot" />
//             </div>
//           )}

//           {isListening && (
//             <div className="listening-indicator">
//               <div className="pulse-ring" />
//               <div className="pulse-ring" />
//               <div className="pulse-ring" />
//             </div>
//           )}

//         </div>

//         {/* ==============================
//             SPEECH TEXT
//         ============================== */}

//         {text && (isSpeaking || isThinking) && (
//           <div className={`speech-bubble ${emotion}`}>
//             <p>{text}</p>
//           </div>
//         )}

//       </div>

//       {/* ==============================
//           STATUS
//       ============================== */}

//       <div className="avatar-status">

//         {!isConnected && (
//           <span>
//             🔄 Connecting...
//           </span>
//         )}

//         {isConnected && isSpeaking && (
//           <span className="status-speaking">
//             🗣️ Speaking...
//           </span>
//         )}

//         {isConnected && isThinking && !isSpeaking && (
//           <span className="status-thinking">
//             🤔 Thinking...
//           </span>
//         )}

//         {isConnected && isListening && !isSpeaking && !isThinking && (
//           <span className="status-listening">
//             👂 Listening...
//           </span>
//         )}

//         {isConnected &&
//           !isSpeaking &&
//           !isThinking &&
//           !isListening && (
//             <span className="status-idle">
//               😊 Ready
//             </span>
//           )}

//       </div>

//     </div>
//   );
// };

// export default SimliAvatar;

